import React, { Component } from "react"
import Button from "../Button/Button"
import Divider from "../Divider/Divider"

import "./hero.css"
import logo from "../images/hibachi-and-you-logo.svg"
import calendar from "../images/calendar.svg"

const Hero = () => (
  <div className="hero">
    <div className="hero__background-container">
      <div className="hero__background" />
    </div>
    <header className="hero__text">
      <img alt="Hibachi and You Logo" className="hero__logo" src={logo} />
      <h1 className="">The Perfect Party</h1>
      <Divider />
      <p>
        Wherever you want it, with:<span> Hibachi & You</span>. We have diverse
        menus, impeccable service, and the ability to adapt to any location.
      </p>
      <Button img={calendar} text="Schedule Party" link="form" />
    </header>
  </div>
)

export default Hero



// WEBPACK FOOTER //
// ./src/Hero/Hero.js